/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, width: NonNullable<unknown>, height: NonNullable<unknown> }} Image_Export_Summary_Line_OneInputs */

const en_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} images (${i?.width}x${i?.height}) + BDN XML`)
};

const fr_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} images (${i?.width}x${i?.height}) + XML BDN`)
};

const de_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Bilder (${i?.width}x${i?.height}) + BDN XML`)
};

const it_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} immagini (${i?.width}x${i?.height}) + BDN XML`)
};

const ru_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изображения ${i?.count} (${i?.width}x${i?.height}) + BDN XML`)
};

const es_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imágenes ${i?.count} (${i?.width}x${i?.height}) + BDN XML`)
};

const zh_cn2_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 图像（${i?.width}x${i?.height}）+ BDN XML`)
};

const ja_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 画像 (${i?.width}x${i?.height}) + BDN XML`)
};

const hi_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} छवियाँ (${i?.width}x${i?.height}) + BDN XML`)
};

const pt_pt2_image_export_summary_line_one = /** @type {(inputs: Image_Export_Summary_Line_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagens ${i?.count} (${i?.width}x${i?.height}) + XML BDN`)
};

/**
* | output |
* | --- |
* | "{count} images ({width}x{height}) + BDN XML" |
*
* @param {Image_Export_Summary_Line_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_line_one = /** @type {((inputs: Image_Export_Summary_Line_OneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_Line_OneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_summary_line_one(inputs)
	if (locale === "de") return de_image_export_summary_line_one(inputs)
	if (locale === "it") return it_image_export_summary_line_one(inputs)
	if (locale === "ru") return ru_image_export_summary_line_one(inputs)
	if (locale === "es") return es_image_export_summary_line_one(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_summary_line_one(inputs)
	if (locale === "ja") return ja_image_export_summary_line_one(inputs)
	if (locale === "hi") return hi_image_export_summary_line_one(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_summary_line_one(inputs)
	return en_image_export_summary_line_one(inputs)
});